export class VideoTooLargeError extends Error {
  constructor() {
    super('Videos cannot be larger than 300 MB')
    this.name = 'VideoTooLargeError'
  }
}

export class UploadLimitError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'UploadLimitError'
  }
}
